import { validationTypes } from "../../../../components/forms/libs/data/ValidationTypes";
import { FormFieldTypes } from "../../../../components/forms/libs/data/formFieldType";

const initState = {
  clientName: "",
  planName:"",
  valName:"",
  eIN: "",
  active: false,
  reportTemplateID:"",
  copyValID:""
};

export const addEditClientValuationFormConfig = {
  name: "Client Details",
  initialState: initState,
  section: [
    {
      sectionId: "basicDetailSection",
      title: "Basic Client Details",
      row: {},
      style: {
        sectionStyle: "col-lg-12 col-md-12",
      },
      wrapperTemplate: <div className="row row-gap"></div>,
      fields: [
        {
          id: "clientName",
          label: "Client",
          Field_Name: "client",
          fieldType: FormFieldTypes.INPUT,
          dataField: "clientName",
          fieldSetting: {
            placeholder: "Client Name",
             allowSpace: true,
            isDisable: true,
          },
          style: {
            containerCss: "col-lg-12 col-md-12",
          },
        },
        {
          id: "planName",
          label: "Plan",
          Field_Name: "plan",
          fieldType: FormFieldTypes.INPUT,
          dataField: "planName",
          fieldSetting: {
            placeholder: "Plan",
             allowSpace: true,
            isDisable: true,
          },
          style: {
            containerCss: "col-lg-12 col-md-12",
          },
        },
        {
          id: "valName",
          label: "Name",
          Field_Name: "name",
          fieldType: FormFieldTypes.INPUT,
          dataField: "valName",
          fieldSetting: {
            placeholder: "Please enter name",
             allowSpace: true,
            isDisable: false,
          },
          validation: [{ type: validationTypes.REQUIRE }],
          style: {
            containerCss: "col-lg-12 col-md-12",
          },  
        },
        {
          id: "planYearBegin",
          label: "Plan Year Begin",
          Field_Name: "begining plan year",
          fieldType: FormFieldTypes.DATEPICKER,
          dataField: "planYearBegin",
          fieldSetting: {
            placeholder: "Please select plan begining year",
             allowSpace: true,
            isDisable: false,
          },
          validation: [{ type: validationTypes.REQUIRE }],
          style: {
            containerCss: "col-lg-6 col-md-6",
          },
        },
        {
          id: "planYearEnd",
          label: "Plan Year End",
          Field_Name: "ending plan year",
          fieldType: FormFieldTypes.DATEPICKER,
          dataField: "planYearEnd",
          fieldSetting: {
            placeholder: "Please select plan ending year",
             allowSpace: true,
            isDisable: false,
          },
          validation: [{ type: validationTypes.REQUIRE }],
          style: {
            containerCss: "col-lg-6 col-md-6",
          },
        },
        {
          id: "reportTemplateID",
          label: "Template",
          Field_Name: "template",
          fieldType: FormFieldTypes.SELECT,
          dataField: "reportTemplateID",
          fieldSetting: {
            placeholder: "Please select template",
             allowSpace: true,
            isDisable: false,
            options: [],
          },
          validation: [{ type: validationTypes.REQUIRE }],
          style: {
            containerCss: "col-lg-6 col-md-6",
          },
        },
        
        {
          id: "copyValID",
          label: "Copy Of Valuation",
          Field_Name: "copy of valuation",
          fieldType: FormFieldTypes.SELECT,
          dataField: "copyValID",
          fieldSetting: {
            placeholder: "Please select copy of valuation",
             allowSpace: true,
            isDisable: false,
          },
          style: {
            containerCss: "col-lg-6 col-md-6",
          },
        },
        
        
      ],
    },
  ],
};
